import { render, staticRenderFns } from "./controlprojectAdd.vue?vue&type=template&id=673b6d3e&scoped=true"
import script from "./controlprojectAdd.vue?vue&type=script&lang=js"
export * from "./controlprojectAdd.vue?vue&type=script&lang=js"
import style0 from "./controlprojectAdd.vue?vue&type=style&index=0&id=673b6d3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673b6d3e",
  null
  
)

export default component.exports